var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-note-dialog',{attrs:{"auction-id":_vm.auctionId,"batch-id":_vm.batchId},on:{"note-added":function($event){return _vm.$emit('note-added')}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"success","depressed":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-plus ")]),_vm._v(" Adauga notita ")],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }